import { SearchParamType } from "@/types/SearchParamType";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
export var formatSince = function (postedDate) {
    return dayjs(postedDate).fromNow();
};
// a11y: contrast ratio between a background color and large text color should be at least 3:1
var avatarColors = [
    "red",
    "gray",
    "orange",
    // "yellow",   // contrast ratio: 2.4
    "green",
    "blue",
    "teal",
    "purple",
    // "cyan",     // contrast ratio 2.44
    "pink", // contrast ratio 4.26
];
var hashCode = function (value) {
    var hash = 0, i, chr;
    if (value.length === 0)
        return hash;
    for (i = 0; i < value.length; i++) {
        chr = value.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
};
export var getColor = function (companyName) {
    var hash = hashCode(companyName);
    return avatarColors[hash % avatarColors.length];
};
export var getCompanyInitials = function (companyName) {
    return companyName
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .split(" ")
        .filter(function (word) { return word.length > 1; })
        .map(function (word) { return word[0]; })
        .slice(0, 2)
        .join("")
        .toUpperCase();
};
export function getUpdatedSearchParams(searchParams, queryValue, locationValue, isRemoteOnlyValue, pageCursor, countryValue, companyValue, occupationValue) {
    if (queryValue === void 0) { queryValue = undefined; }
    if (locationValue === void 0) { locationValue = undefined; }
    if (isRemoteOnlyValue === void 0) { isRemoteOnlyValue = undefined; }
    if (pageCursor === void 0) { pageCursor = undefined; }
    if (countryValue === void 0) { countryValue = undefined; }
    if (companyValue === void 0) { companyValue = undefined; }
    if (occupationValue === void 0) { occupationValue = undefined; }
    var params = new URLSearchParams(searchParams);
    setSanitizedParam(params, SearchParamType.WHAT, queryValue);
    setSanitizedParam(params, SearchParamType.WHERE, locationValue);
    setSanitizedParamBool(params, SearchParamType.IS_REMOTE_ONLY, isRemoteOnlyValue);
    setSanitizedParam(params, SearchParamType.CURSOR, pageCursor);
    // Always preserve country parameter - only update if explicitly provided
    if (countryValue !== undefined) {
        setSanitizedParam(params, SearchParamType.COUNTRY, countryValue);
    }
    if (companyValue !== undefined) {
        setSanitizedParam(params, SearchParamType.COMPANY, companyValue);
    }
    if (occupationValue !== undefined) {
        setSanitizedParam(params, SearchParamType.OCCUPATION, occupationValue);
    }
    if (params.toString() != searchParams.toString() &&
        (pageCursor == undefined || pageCursor == "0")) {
        params.delete(SearchParamType.CURSOR); // start from page 1 again
        params.delete(SearchParamType.JOB_KEY); // reset job selection on new search
    }
    return params;
}
function setSanitizedParam(params, paramName, paramValue) {
    if (paramValue === void 0) { paramValue = undefined; }
    if (paramValue !== undefined && paramValue !== "") {
        params.set(paramName, paramValue);
    }
    else {
        params.delete(paramName);
    }
}
function setSanitizedParamBool(params, paramName, paramValue) {
    if (paramValue === void 0) { paramValue = undefined; }
    if (paramValue !== undefined && paramValue) {
        params.set(paramName, "true");
    }
    else {
        params.delete(paramName);
    }
}
export var getCurrentPageNumber = function (pageCursors) {
    var pageCursorsArray = Array.from(pageCursors.entries());
    for (var _i = 0, pageCursorsArray_1 = pageCursorsArray; _i < pageCursorsArray_1.length; _i++) {
        var _a = pageCursorsArray_1[_i], pageNumber = _a[0], cursor = _a[1];
        if (cursor == "") {
            return pageNumber;
        }
    }
    throw new Error("No current page found");
};
export var getLinksForAnchor = function (anchor, properties) {
    return properties.links.find(function (link) { return link.anchor.toLowerCase() === anchor.toLowerCase(); });
};
export var getLinksForAnchors = function (anchors, properties) {
    return new Map(anchors.map(function (anchor) { return [anchor, getLinksForAnchor(anchor, properties)]; }));
};
